module.exports = __webpack_public_path__ + "img/ship.9d815778.svg";